import ShareableLinkModal from './ShareableLinkModal';

export default ShareableLinkModal;
